<template>
    <div>
	<div class="list-group no-border border-radius-2 mb-3">
		<div class="list-group-item list-group-item-primary d-flex align-items-center justify-content-between">
			<strong>{{ title == 0 ? $t('internal-learning-outcomes') : $t('external-learning-outcomes') }} </strong>
             <div v-if="$UserSession.hasPriv.call(this, 'CURRICULUM_MANAGE')">
                <button class="btn btn-primary btn-sm" v-if="!new_lo" @click="new_lo = true;">{{ $t('new') }}</button>
                <button class="btn btn-danger btn-sm" v-else @click="new_lo = false;">{{ $t('cancel') }}</button>
            </div>
		</div>
        <div
            class="list-group-item"
            v-for="(item, index) in LOclass"
            :key="`${index}`"
        >
            <div class="mr-4 mb-0">
                <h3 class="mb-0">
                    <router-link 
                        class="link-bare" 
                        :to="`/curriculum-mapping/learning-outcomes/group/${item.id}`"
                    >
                        {{item.title}} {{ item.total ? `(${item.total})`: '' }}
                    </router-link>
                    <b-badge style="font-size: 1rem; float: right;"
                        :variant="getVariant(percentage(item))">
                        {{ `${Math.round(percentage(item)*100)} %`}}
                    </b-badge>
                </h3>
                <p v-if="item.note">{{ item.note }}</p>
                <label v-if="item.curricula.length" class="small">
                    {{ $t('curricula') }}: {{ getCurriculaString(item.curricula) }}
                </label>
            </div>
        </div>
	</div>
    <div v-if="new_lo" class="list-group border-radius-2 no-border mb-3">
        <div class="list-group-item">
            <div class="card mx-1 mb-2">
                <h4 class="card-header">{{ $t('new-learning-outcome-group') }}</h4>
                <div class="card-body">
                    <TextInput 
                        :label="$t('title')" 
                        v-model="learningoutcomegroup.title" 
                    />
                    <TextAreaInput 
                        :label="$t('notes')" 
                        v-model="learningoutcomegroup.note" 
                    />
                    <button 
                        class="btn btn-secondary float-right" 
                        @click="saveLOG" 
                        :disabled="!learningoutcomegroup.title"
                    >
                        {{ $t('add') }}
                    </button>
                </div>
            </div>
        </div>
        
    </div>
    <!-- <div class="list-group border-radius-2 no-border mb-3" v-if="mapping_progress">
		<WidgetHeader link="/reports/report/progress">{{ $t('progress') }}</WidgetHeader>
		<div class="list-group-item">
			<Report
				:loadedconfig="mapping_progress"
			/>
		</div>
	</div> -->
    </div>
</template>

<script>
// import WidgetHeader from "src/components/widgets/WidgetHeader.vue";
// import Report from '../Reports/Report.vue';

export default {
	components: {
        // WidgetHeader,
        // Report
	},
    props: {
        LOclass: Array,
        title: String,
        mapping_progress: Object,
        loService: {
            type: Object,
            default: null
        }
    },
    data() {
    	return {
    		selected: false,
            learningoutcomegroup: {},
            new_lo: false
    	}
    },
	methods: {
		selectItem: function(){
			this.selected = !this.selected;
		},
        getVariant(number) {
            if(number >= 0.95 && number <= 1) return 'success';
            else if (number >= 0.9 && number < 0.95) return 'warning';
            else return 'danger';
        },
        saveLOG() {
            this.learningoutcomegroup.class = this.title
            this.loService.saveGroup(this.learningoutcomegroup)
            .then(() => {
                this.new_lo = false;
                this.learningoutcomegroup = {};
                this.$emit('saved');
            })
            //.finally(() => this.$store.commit("hideBlockingSpinner"));
        },
        percentage(item){
            if(item.total !== 0) return  Number(item.mapped/item.total)
            else return 0;
        },
        getCurriculaString(curricula){
            return curricula.map(x => x.title).join(', ')
        }
	}
};
</script>
